document.querySelectorAll('.readmore').forEach(function(element) {
    element.addEventListener('click', function() {
        document.querySelectorAll('.test2').forEach(function(el) {
            el.style.display = 'block';
        });
        document.querySelectorAll('.readmore').forEach(function(el) {
            el.style.display = 'none';
        });
        document.querySelectorAll('.readless').forEach(function(el) {
            el.style.display = 'block';
        });
    });
});

document.querySelectorAll('.readless').forEach(function(element) {
    element.addEventListener('click', function() {
        document.querySelectorAll('.test2').forEach(function(el) {
            el.style.display = 'none';
        });
        document.querySelectorAll('.readmore').forEach(function(el) {
            el.style.display = 'block';
        });
        document.querySelectorAll('.readless').forEach(function(el) {
            el.style.display = 'none';
        });
    });
});

var tab = document.querySelectorAll(".tab");
               tab.forEach(function(ques) {
            var btn = ques.querySelector(".tab-toggle");
            btn.addEventListener("click", function () {
                tab.forEach(function (closed) {
                    if (closed !== ques) {
                        closed.classList.remove("show-item");}  });
                ques.classList.toggle("show-item"); });});


const login= document.querySelector(".btn_login")
 const close= document.querySelector(".btn-close")
 if(login){
     login.addEventListener("click",function(){
    document.querySelector(".pop-up").classList.add("active")
       
});
 }
if(close){
close.addEventListener("click",function(){
    document.querySelector(".pop-up").classList.remove("active")
    
});
}

  window.addEventListener('DOMContentLoaded', function() {
    var limitChar = 33;
    var productTitles = document.querySelectorAll('.productitem--title');
    
    if (productTitles.length > 0) {
        productTitles.forEach(function(title) {
            var link = title.querySelector('a');
            var text = link.textContent.trim();
            
            if (text.length > limitChar) {
                text = text.substr(0, limitChar) + '...';
                link.textContent = text;
            }
        });
    }
});


 // Add item field in bulk order page 
(function () {
  var bulkForm = document.getElementById('bulk-order-form');
  if (!bulkForm) return;
  bulkForm.setAttribute('novalidate', 'novalidate');
 
  var itemContainer = bulkForm.querySelector('.item_container');
  var itemContainerAdd = bulkForm.querySelector('.item_container_add');
  var addBtn = bulkForm.querySelector('.btnmore');
  var id = 0;
 
  function addMoreFields() {
    var oldMsg = bulkForm.querySelector('.max-limit-message');
    if (oldMsg) oldMsg.remove();
 
    var totalRows = itemContainerAdd.querySelectorAll('.form-fields-columns').length;
 
    if (totalRows < 5) {
      id++;
      var wrapper = document.createElement('div');
      wrapper.className = 'form-fields-columns';
      wrapper.setAttribute('data-id', id);
 
      wrapper.innerHTML =
        '<div class="form-field form-field--half" id="dropdown-' + id + '">' +
          '<label for="user_requirement-' + id + '" class="form-field-title">What do you require?</label>' +
          '<select id="user_requirement-' + id + '" name="contact[Item-' + id + ']" class="form-field-input form-field-text" required>' +
            '<option value="" disabled selected>Select what you require</option>' +
            '<option>Chairs</option>' +
            '<option>Desks</option>' +
            '<option>Storage</option>' +
            '<option>Lockers</option>' +
            '<option>Accessories</option>' +
            '<option>All of the Above</option>' +
            '<option>Other</option>' +
          '</select>' +
          '<span class="field-error-message" data-error-for="user_requirement-' + id + '">Please select what you require.</span>' +
        '</div>' +
        '<div class="form-field form-field--half" id="quant-' + id + '">' +
          '<label for="user_quantity-' + id + '" class="form-field-title">Quantity</label>' +
          '<select id="user_quantity-' + id + '" name="contact[Quantity-' + id + ']" class="form-field-input form-field-text" required>' +
            '<option value="" disabled selected>Select quantity</option>' +
            '<option>1-10</option>' +
            '<option>11-20</option>' +
            '<option>21-40</option>' +
            '<option>41-50</option>' +
            '<option>50+</option>' +
          '</select>' +
          '<span class="field-error-message" data-error-for="user_quantity-' + id + '">Please select a quantity.</span>' +
        '</div>' +
        '<button type="button" class="remove-item" aria-label="Remove item">' +
          '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20" height="20">' +
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 4h6m-7 0a2 2 0 012-2h4a2 2 0 012 2m-7 0h8" />' +
          '</svg>' +
        '</button>';
 
      itemContainerAdd.appendChild(wrapper);
    } else {
      var message = document.createElement('span');
      message.className = 'max-limit-message';
      message.textContent = 'You can add a maximum of 6 items only.';
      addBtn.insertAdjacentElement('afterend', message);
    }
  }
 
  if (addBtn) {
    addBtn.addEventListener('click', function (event) {
      event.preventDefault();
      addMoreFields();
    });
  }
 
  bulkForm.addEventListener('click', function (event) {
    var button = event.target.closest('.remove-item');
    if (button) {
      event.preventDefault();
      var row = button.closest('.form-fields-columns');
      if (row) row.remove();
 
      var oldMsg = bulkForm.querySelector('.max-limit-message');
      if (oldMsg) oldMsg.remove();
    }
  });
 
  function isPlaceholderSelect(field) {
    if (field.selectedIndex < 1) return true;
    var opt = field.options[field.selectedIndex];
    return !opt || opt.disabled;
  }
 
  function getError(field) {
    var value = (field.value || '').trim();
 
    if (field.tagName === 'SELECT') {
      return isPlaceholderSelect(field) ? 'Please choose an option.' : '';
    }
    if (value === '') {
      return 'This field is required.';
    }
    if (field.type === 'email') {
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
      return emailOk ? '' : 'Please enter a valid email address.';
    }
    if (field.type === 'tel') {
      // allow spaces, +, -, ( ) — then require 8 to 15 digits (E.164 max)
      var onlyAllowed = /^[0-9+\-()\s]+$/.test(value);
      var digits = value.replace(/\D/g, '');
      return (onlyAllowed && digits.length >= 8 && digits.length <= 15)
        ? '' : 'Please enter a valid phone number (8-15 digits).';
    }
    return '';
  }
 
  function getErrorEl(field) {
    var el = bulkForm.querySelector('[data-error-for="' + field.id + '"]');
    if (!el) {
      // create one if the markup doesn't have it, so the message always shows
      el = document.createElement('span');
      el.className = 'field-error-message';
      el.setAttribute('data-error-for', field.id);
      field.insertAdjacentElement('afterend', el);
    }
    return el;
  }
 
  function showError(field, message) {
    var el = getErrorEl(field);
    field.classList.add('form-field-error');
    field.setAttribute('aria-invalid', 'true');
    el.textContent = message;
    el.classList.add('is-visible');
  }
 
  function clearError(field) {
    var el = bulkForm.querySelector('[data-error-for="' + field.id + '"]');
    field.classList.remove('form-field-error');
    field.removeAttribute('aria-invalid');
    if (el) el.classList.remove('is-visible');
  }
 
  function validateForm() {
    var firstInvalid = null;
    bulkForm.querySelectorAll('[required]').forEach(function (field) {
      var message = getError(field);
      if (message) {
        showError(field, message);
        if (!firstInvalid) firstInvalid = field;
      } else {
        clearError(field);
      }
    });
    if (firstInvalid) firstInvalid.focus();
    return !firstInvalid;
  }
 

  function recheck(event) {
    var field = event.target;
    if (field.matches && field.matches('[required]') && field.classList.contains('form-field-error')) {
      var message = getError(field);
      if (message) { showError(field, message); } else { clearError(field); }
    }
  }
  bulkForm.addEventListener('input', recheck);
  bulkForm.addEventListener('change', recheck);
  var sendBtn = bulkForm.querySelector('button[type="submit"], input[type="submit"]');
  if (sendBtn) {
    sendBtn.addEventListener('click', function (event) {
      if (!validateForm()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }
 
  bulkForm.addEventListener('submit', function (event) {
    if (!validateForm()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
 
  var nativeSubmit = bulkForm.submit;
  bulkForm.submit = function () {
    if (validateForm()) nativeSubmit.call(bulkForm);
  };
  var phoneInput = bulkForm.querySelector('#contact_phone');
if (phoneInput) {
  phoneInput.addEventListener('input', function () {
    var cleaned = this.value.replace(/[^0-9+\-()\s]/g, '');
    if (cleaned !== this.value) this.value = cleaned;
  });
}
})();



document.querySelectorAll('.options-selection__input-select-wrapper').forEach(function(input) {
    input.addEventListener('change', function() {
        var cust_price_element = document.querySelector('.product-pricing .price__current .money');
        var cust_price = parseFloat(cust_price_element.textContent.replace(/[^0-9\.-]+/g,""));
        var install_price = "$" + (cust_price / 4);
        document.querySelector('.payment-4-installment p b .h2').innerHTML = install_price;
    });
});


window.openTab = function (evt, tabName) {
    // Hide all tab content
    var tabContent = document.getElementsByClassName("meta-tab");
    for (var i = 0; i < tabContent.length; i++) {
        tabContent[i].style.display = "none";
    }

    // Remove "active" class from all tab buttons
    var tabLinks = document.getElementsByClassName("tab-link");
    for (var i = 0; i < tabLinks.length; i++) {
        tabLinks[i].classList.remove("active");
    }

    // Show selected tab & mark button as active
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.classList.add("active");
};

// Run after DOM loads
document.addEventListener("DOMContentLoaded", function () {
    var defaultTab = document.querySelector(".tab-link.active");
    var firstTab = document.querySelector(".tab-link");

    if (defaultTab) {
        defaultTab.click();
    } else if (firstTab) {
        firstTab.click();
    }
});

// To hide the alert when varient shows error 
document.addEventListener("DOMContentLoaded", function () {
   const alertHide = document.querySelector(".message-banner--container");
   const varientSection = document.getElementById("product-options-ho4ed2r6cwo");       
      if (varientSection) {
        alertHide.style.display = "none"; 
      }   
  });

// Faq section for blog

document.addEventListener("DOMContentLoaded", () => {
  const articleContent = document.querySelector(".article--content");
  if (!articleContent) return;

  let html = articleContent.innerHTML;

  /* ---------- CHECK FAQ ---------- */
  if (!html.includes("<!-- FAQ -->")) return;

  const parts = html.split("<!-- FAQ -->");
  const contentHTML = parts[0];
  const faqRaw = parts[1];

  let faqHTML = "";

  const faqItems = faqRaw
    .split("@@@")
    .map(item => item.trim())
    .filter(Boolean);

  if (faqItems.length) {
    faqHTML = `
      <div class="blog-faq">
        <h2>FAQs</h2>
        ${faqItems.map(item => {
          const [q, a] = item.split("|||");
          if (!q || !a) return "";

          // ✅ Better cleaning
          const cleanQ = q.replace(/<\/?p[^>]*>/gi, "").trim();

          return `
            <div class="faq-item">
              <div class="faq-question" role="button" aria-expanded="false">
                <p class="faq-text">${cleanQ}</p>
                <span class="faq-icon"></span>
              </div>
              <div class="faq-answer">
                <p>${a.trim()}</p>
              </div>
            </div>
          `;
        }).join("")}
      </div>
    `;
  }

  /* ---------- RENDER ---------- */
  articleContent.innerHTML = contentHTML + faqHTML;

  /* ---------- ACCORDION ---------- */
  const wrapper = articleContent.querySelector(".blog-faq");
  if (!wrapper) return; // ✅ safety fix

  wrapper.addEventListener("click", (e) => {
    const question = e.target.closest(".faq-question");
    if (!question) return;

    const item = question.closest(".faq-item");
    const isActive = item.classList.contains("active");

    // Close all
    wrapper.querySelectorAll(".faq-item").forEach(el => {
      el.classList.remove("active");
      el.querySelector(".faq-question")
        ?.setAttribute("aria-expanded", "false");
    });

    // Open clicked
    if (!isActive) {
      item.classList.add("active");
      question.setAttribute("aria-expanded", "true");
    }
  });
});
